// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import App from './App.vue'

// ─── BOOTSTRAP 5 (No jQuery needed) ──────────────────────────────────
import './assets/css/bootstrap.css'
// Updated Bootstrap import - using the correct path for Bootstrap 4.6.2
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap-icons/font/bootstrap-icons.css'

// ─── JQUERY (Only for legacy plugins like Owl Carousel) ─────────────
import $ from 'jquery'
window.$ = window.jQuery = $

// ─── OWL CAROUSEL ────────────────────────────────────────────────────
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

// ─── CUSTOM STYLES ───────────────────────────────────────────────────
import '@/assets/css/app-style.css'

// ─── UTILITY IMPORTS ─────────────────────────────────────────────────
import { loadCustomScripts } from '@/utils/loadCustomScripts.js'
import { testAllComponents } from '@/utils/componentTester.js'

/**
 * Initialize Vue application with proper dependency loading
 */
async function initializeApp() {
  try {

    // ─── 1. CREATE VUE APP ───────────────────────────────────────────
    const app = createApp(App)

    // ─── 2. SETUP PINIA STORE ────────────────────────────────────────
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)
    app.use(pinia)

    // ─── 3. SETUP ROUTER ─────────────────────────────────────────────
    app.use(router)

    // ─── 4. INITIALIZE AUTH STORE ────────────────────────────────────
    const { useAuthStore } = await import('@/stores/auth')
    const authStore = useAuthStore()
    authStore.initialize()

    // ─── 5. MOUNT VUE APP ────────────────────────────────────────────
    app.mount('[data-vue-app]')

    // ─── 6. VERIFY BOOTSTRAP 5 ───────────────────────────────────────
    await new Promise((resolve) => setTimeout(resolve, 100))


    // ─── 8. LOAD CUSTOM SCRIPTS ──────────────────────────────────────
    await loadCustomScripts()

    // ─── 9. TEST COMPONENTS (Development only) ───────────────────────
    if (import.meta.env.DEV) {
      testAllComponents()
    }

  } catch (error) {
    console.error('❌ Application initialization failed:', error)
  }
}

// ─── START APPLICATION ───────────────────────────────────────────────
initializeApp()
